<template>
  <div class="dynamic-detail-body">
    <div style="height: 114px">
      <div class="dynamic-head-box" :class="{ 'scroll-head': scrollShow }">
        <div>
          <p style="margin-top: 0">
            {{ info.projectName }}
          </p>
          <div class="knowledge-case-lable">
            <p>
              <span v-for="(tag,ti) in info.tagNames" :key="ti">{{ tag }}</span>
            </p>
            <div>
              分享至：
              <span @click="share('qzone')"><img src="@/assets/img/fxkj.png" /></span>
              <span @click="share('qq')"><img src="@/assets/img/fxqq.png" /></span>
              <span @click="share('db')"><img src="@/assets/img/db.png" /></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="more-dynamic-detail-content-body">
      <div class="more-dynamic-content-left-body">
        <div class="knowledge-scenes-info-descriptions">
          <a-descriptions :title="false" bordered :column="2" size="small">
            <a-descriptions-item label="供应商">{{ info.bidSource }}</a-descriptions-item>
            <a-descriptions-item label="采购业主">{{ info.purUnitName }}</a-descriptions-item>
            <a-descriptions-item label="采购金额">￥{{ info.bidWinningAmount }}</a-descriptions-item>
            <a-descriptions-item label="成交时间">{{ info.winPublishTime }}</a-descriptions-item>
            <a-descriptions-item label="采购地区" :span="2">{{ info.locationName }}</a-descriptions-item>
            <!--            <a-descriptions-item label="成交内容" :span="2"-->
            <!--            >人事管理信息系统软件、核酸检测信息系统、测试评估认证服务、行业应用软件-->
            <!--            </a-descriptions-item-->
            <!--            >-->
          </a-descriptions>
        </div>
        <div class="more-dynamic-detail-content">
          <p class="knowledge-scenes-info-title"><span>公告详情</span></p>
          <div class="ql-container ql-snow">
            <div class="more-dynamic-detail-content-text ql-editor" v-html="info.projectDesc">
            </div>
          </div>
        </div>
      </div>
      <div class="more-dynamic-right-body">
        <span @click="noUrl"><img src="@/assets/img/ggimg.jpg" /></span>
        <!--        <div>-->
        <!--          <div class="more-dynamic-title">-->
        <!--            <p>其他推荐</p>-->
        <!--          </div>-->
        <!--          <div class="more-dynamic-list">-->
        <!--            <div>-->
        <!--              <p>探索技术与应用融合的区块链 实现产...</p>-->
        <!--              <div>-->
        <!--                <span>2021-8-15 发布</span>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      scrollShow: false,
      newDetail: "",
      newsList: []
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    info() {
      return this.$route.params || {};
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    noUrl() {
      this.$message.warning("暂无跳转链接！");
    },
    handleScroll() {
      this.scrollShow = document.documentElement.scrollTop > 210;
    },
    share(type) {
      let newDetail = this.newDetail;
      //qq空间分享接口
      if (type == "qzone") {
        window.open(
          `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=` +
          window.location.href
        );
      }
      //qq好友接口的传参
      if (type == "qq") {
        window.open(
          `http://connect.qq.com/widget/shareqq/index.html?url=` +
          encodeURIComponent(window.location.href) +
          `?sharesource=qzone&title=${newDetail.newsName}&pics=图片地址&summary=''`
        );
      }
      if (type == "db") {
        window.open(
          `http://shuo.douban.com/!service/share?href=` +
          encodeURIComponent(window.location.href) +
          `&name=${newDetail.newsName}&text=''&image=图片地址&starid=0&aid=0&style=11`
        );
      }
    }
  }
};
</script>

<style lang="less" scoped>
.dynamic-detail-body {
  padding-bottom: 40px;
}

.knowledge-scenes-info-descriptions {
  padding: 24px;
  background: #fff;
  margin-bottom: 24px;
}

.knowledge-scenes-info-title {
  position: relative;
  display: flex;
  margin-bottom: 24px;

  > span {
    font-size: 16px;
    color: #262626;
    line-height: 16px;
    position: relative;
    z-index: 2;
    font-weight: bold;
  }

  &::after {
    content: "";
    position: absolute;
    width: 96px;
    height: 8px;
    background: #1abc9c;
    left: 0;
    bottom: -4px;
    z-index: 1;
  }
}

.dynamic-head-box {
  background: #fff;

  > div {
    width: 1200px;
    margin: 0 auto;
    padding: 24px 0;

    > p {
      font-size: 24px;
      line-height: 24px;
      margin: 20px 0;
    }

    .knowledge-case-lable {
      display: flex;
      align-items: center;
      justify-content: space-between;

      > p {
        font-size: 12px;
        display: flex;
        color: #262626;

        > span {
          height: 22px;
          background: #fafafa;
          border: 1px solid #d9d9d9;
          border-radius: 2px;
          margin-right: 8px;
          line-height: 20px;
          padding: 0 10px;
        }
      }

      > div {
        display: flex;
        align-items: center;

        > span {
          margin-left: 6px;
          cursor: pointer;

          > img {
            display: block;
          }
        }
      }
    }
  }
}

.more-dynamic-detail-content-body {
  display: flex;
  width: 1200px;
  margin: 24px auto 0;

  .more-dynamic-content-left-body {
    flex: 1;

    .more-dynamic-detail-content {
      background: #fff;
      padding: 30px;

      .more-dynamic-detail-content-text {
        line-height: 26px;
        padding-bottom: 60px;
        padding: 0;
      }

      .more-dynamic-detail-content-annex {
        margin-top: 24px;

        > p {
          font-size: 16px;
          line-height: 16px;
          position: relative;
          margin-bottom: 36px;

          > span {
            display: block;
            line-height: 16px;
            position: relative;
            z-index: 2;
          }

          &::after {
            content: "";
            position: absolute;
            width: 64px;
            height: 8px;
            background: #1abc9c;
            left: 0;
            bottom: -4px;
          }
        }

        > div {
          > div {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 32px;
            padding: 0 16px;
            margin-bottom: 16px;
            cursor: pointer;

            &:last-child {
              margin-bottom: 0;
            }

            > div {
              display: flex;
              align-items: center;

              > img {
                margin-right: 8px;
              }

              > p {
                max-width: 400px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }

            > span {
              color: #1abc9c;
              cursor: pointer;
              display: none;
            }

            &:hover {
              background: #f5f5f5;

              > span {
                display: block;
              }
            }
          }
        }
      }
    }

    .dynamic-up-down {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 24px 0 60px;

      > p {
        display: flex;

        > span {
          color: #1abc9c;
          cursor: pointer;
          max-width: 300px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  .more-dynamic-right-body {
    width: 280px;
    margin-left: 24px;

    > span {
      display: block;
      cursor: pointer;
      margin-bottom: 24px;

      > img {
        display: block;
      }
    }

    > div {
      background: #fff;

      .more-dynamic-title {
        height: 48px;
        padding: 0 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #f0f0f0;

        > p {
          font-size: 16px;
        }

        > span {
          font-size: 12px;
          color: #8c8c8c;
          cursor: pointer;
        }
      }

      .more-dynamic-list {
        padding: 0 16px;

        > div {
          border-bottom: 1px solid #f0f0f0;
          padding: 16px 0;
          cursor: pointer;

          > p {
            line-height: 14px;
            margin-bottom: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          > div {
            display: flex;

            > span {
              margin-right: 16px;
              font-size: 12px;
              line-height: 12px;
              color: #8c8c8c;
            }
          }

          &:last-child {
            border-bottom: 0;
          }
        }
      }
    }
  }
}

.scroll-head {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.08);

  > div {
    > p {
      margin-top: 0;
    }
  }
}
</style>
<style>
.ant-page-header.has-breadcrumb {
  padding: 0;
  line-height: 14px;
}

.ant-page-header.has-breadcrumb a:hover {
  color: #1abc9c;
}

.before-content-body {
  background: #f7f7f7;
}

.more-dynamic-detail-content .ql-container.ql-snow {
  border: none;
}
</style>
